// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_5f4d971","activeTableButton":"_043bfdc","badge":"_ca4b88f"};